/**
 * Oversetter fra ISO dato/tid til forenklet lokal dato tid: '2020-01-01 12:30'
 * @param t
 */
export function convertToDateTimeString(t: string): string {
  const s = t.split('T');
  return s[0] + ' ' + s[1].substring(0, 5);
}
